// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"3344c402","660":"a7fc1575","846":"986cc1c1"}[chunkId] + ".chunk.js";
};